import type WordpressFeaturedContent from "@gik/core/models/wordpress/WordpressFeaturedContent";

export function getFeaturedContentTitle(
	featuredContent: WordpressFeaturedContent[],
	slug: string,
): string {
	const entry = featuredContent?.find((item) => item.slug === slug);
	if (entry && entry.acf && entry.acf.section_title) {
		return entry.acf.section_title;
	}
	return "";
}
